import React from "react";
import themePropTypes from "../theme-prop-types";
import clockIcon from "./assets/icons/clock.svg";
import Spinner from "./spinner";

const Input = React.forwardRef(
  (
    {
      name,
      value = "",
      onChange,
      onEnterDown,
      invalid,
      params,
      placeholder = "",
      maxLength,
      className = "",
      showLoadingSpiner = false,
      useTimeIcon = false,
      disableAutoComplete = false,
      ariaLabel = "",
      ...props
    },
    ref
  ) => {
    return (
      <div className='input_container'>
        <input
          {...props}
          ref={ref}
          data-testid={`input-${name}`}
          id={name}
          className={`input-web-sdk${params ? ` ${params}` : ""}${
            invalid ? " invalid" : ""
          } ${className}`}
          value={value}
          maxLength={maxLength}
          onChange={event => onChange(event, name)}
          onKeyDown={onEnterDown}
          aria-label={ariaLabel || name}
          placeholder={placeholder}
          autoComplete={disableAutoComplete ? "off" : "on"}
        />
        <div className='input_icon'>
          {showLoadingSpiner ? (
            <Spinner />
          ) : useTimeIcon ? (
            <img alt='clock-icon' src={clockIcon} />
          ) : null}
        </div>
      </div>
    );
  }
);

Input.displayName = "Input";
Input.propTypes = themePropTypes.input;

export default Input;
